<div class="dialog" [class.blocked]="cannotDelete">
    <!-- Blocking overlay when user lost delete permissions -->
    <div *ngIf="cannotDelete" class="blocking-overlay">
        <div class="blocking-message">
            <icc-icon name="warning" class="warning-icon"></icc-icon>
            <p>{{ 'COMPLAINT_APPOINTMENT|Reklamacja została zmodyfikowana przez innego użytkownika. Nie możesz już usunąć tej wizyty.' | translate }}</p>
            <div class="blocking-actions">
                <button iccButton appearance="primary" (click)="close()">
                    {{ 'INTERFACE|Zamknij' | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="dialog-header">
        <h3>{{ 'COMPLAINT_APPOINTMENT|Uwaga' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical w-100">

            <h2>{{ 'COMPLAINT_APPOINTMENT|Czy chcesz usunąć wizytę?' | translate }}</h2>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="removeAppointment()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Tak' | translate}}
            </button>
            <button
                [disabled]="!data.appointment.date"
                iccButton
                (click)="close()"
                appearance="primary"
            >
                {{ 'INTERFACE|Nie' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>